import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import SEO from "../components/SEO";

/**
 * Страница для несуществующих адресов.
 *
 * Vercel отдаёт build/404.html с кодом 404 для неизвестных адресов.
 * noindex сохраняется и после запуска React.
 */
export const NotFoundPage = () => (
  <div className="min-h-screen bg-white flex flex-col" data-testid="not-found-page">
    <SEO
      title="Страница не найдена"
      description="Такой страницы нет. Перейдите в каталог курсов."
      noindex
    />
    <Header />

    <div className="flex-1 flex items-center justify-center px-6 py-24">
      <div className="text-center">
        <div className="text-7xl font-bold text-teal-600 mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Страница не найдена</h1>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          Возможно, адрес введён с ошибкой или страница была перемещена.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/"
            className="fokeev-primary-link"
          >
            На главную
          </Link>
          <Link
            to="/courses"
            className="course-catalog-link"
          >
            <span className="course-catalog-text">Все курсы</span><span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
);

export default NotFoundPage;
